import { Record } from 'immutable';
import { Utils, C } from '@kineticdata/bundle-common';
const { withPayload } = Utils;
const ns = Utils.namespaceBuilder('services/service');

export const types = {
  FETCH_SERVICE_REQUEST: ns('FETCH_SERVICE_REQUEST'),
  FETCH_SERVICE_SUCCESS: ns('FETCH_SERVICE_SUCCESS'),
  FETCH_SERVICE_FAILURE: ns('FETCH_SERVICE_FAILURE'),
};

export const actions = {
  fetchServiceRequest: withPayload(types.FETCH_SERVICE_REQUEST),
  fetchServiceSuccess: withPayload(types.FETCH_SERVICE_SUCCESS),
  fetchServiceFailure: withPayload(types.FETCH_SERVICE_FAILURE),
};

export const State = Record({
  id: null,
  data: null,
  loading: false,
  error: null,
});

export const reducer = (state = State(), { type, payload }) => {
  switch (type) {
    case types.FETCH_SERVICE_REQUEST:
      return state
        .set('id', payload)
        .update(
          'data',
          d => (!d || d.values[C.FIELD_SERVICE_ID] !== payload ? null : d),
        )
        .set('loading', true)
        .set('error', null);
    case types.FETCH_SERVICE_SUCCESS:
      return payload.id === state.id
        ? state.set('data', payload.data).set('loading', false)
        : state;
    case types.FETCH_SERVICE_FAILURE:
      return payload.id === state.id
        ? state.set('error', payload.error).set('loading', false)
        : state;
    default:
      return state;
  }
};

export default reducer;
